import { WidgetsQuestionModel } from "./widgets-question.model"

export class PostQuestionModel {
    
     constructor(model: WidgetsQuestionModel[]){
        this.questionData= {
            "Label": model["Label"],
            "Namespace": model["NameSpace"],
            "Description": model["Description"],
            "Template": model["Template"],
            "TypeId": model["TypeId"],
            "Tags": this.convertTagsToString(model["QuestionTags"]),
            "CreatedBy": model["CreatedBy"]
        }
     }

     public questionData : {
        "Label": string,
        "Namespace": string,
        "Description": string,
        "Template": string,
        "TypeId": number,
        "Tags": string[],
        "CreatedBy": string
     }

     private convertTagsToString(tags: {Id: number, QuestionId: number, Name: string}[]): string[]{
        const newTags: string[] = [];
        tags.forEach(item => {
            newTags.push(item.Name);
        })
        return newTags;
     }

    
}
